import { render, staticRenderFns } from "./ni-icon-busy-medium.vue?vue&type=template&id=08922acf"
import script from "./ni-icon-busy-medium.vue?vue&type=script&lang=js"
export * from "./ni-icon-busy-medium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports